module.exports = __webpack_public_path__ + "img/ride-stats.41536d1f.svg";